var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDesktopTop = function SvgDesktopTop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 30,
    viewBox: "0 0 1280 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_905_72067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H1264C1272.84 0 1280 7.16345 1280 16V30H0V16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 11.625,
    width: 8.75,
    height: 8.75,
    rx: 4.375,
    fill: "#C92727"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.125,
    y: 11.625,
    width: 8.75,
    height: 8.75,
    rx: 4.375,
    fill: "#E9D229"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.25,
    y: 11.625,
    width: 8.75,
    height: 8.75,
    rx: 4.375,
    fill: "#3DAD63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_905_72067"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H1264C1272.84 0 1280 7.16345 1280 16V30H0V16Z",
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDesktopTop);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4MCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDEyODAgMzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF85MDVfNzIwNjcpIj4KPHBhdGggZD0iTTAgMTZDMCA3LjE2MzQ0IDcuMTYzNDQgMCAxNiAwSDEyNjRDMTI3Mi44NCAwIDEyODAgNy4xNjM0NSAxMjgwIDE2VjMwSDBWMTZaIiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB3aWR0aD0iMTI4MCIgaGVpZ2h0PSIzMCIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMjAiIHk9IjExLjYyNSIgd2lkdGg9IjguNzUiIGhlaWdodD0iOC43NSIgcng9IjQuMzc1IiBmaWxsPSIjQzkyNzI3Ii8+CjxyZWN0IHg9IjMzLjEyNSIgeT0iMTEuNjI1IiB3aWR0aD0iOC43NSIgaGVpZ2h0PSI4Ljc1IiByeD0iNC4zNzUiIGZpbGw9IiNFOUQyMjkiLz4KPHJlY3QgeD0iNDYuMjUiIHk9IjExLjYyNSIgd2lkdGg9IjguNzUiIGhlaWdodD0iOC43NSIgcng9IjQuMzc1IiBmaWxsPSIjM0RBRDYzIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfOTA1XzcyMDY3Ij4KPHBhdGggZD0iTTAgMTZDMCA3LjE2MzQ0IDcuMTYzNDQgMCAxNiAwSDEyNjRDMTI3Mi44NCAwIDEyODAgNy4xNjM0NSAxMjgwIDE2VjMwSDBWMTZaIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";